import { useEffect, useState } from "react";
import { socket } from "../socket";

const emojiOptions = [
    { label: "Thank You", emoji: "❤️" },
    { label: "Courageous", emoji: "🛡️" },
    { label: "Respect", emoji: "👑" },
    { label: "Powerful", emoji: "🌟" },
    { label: "Heard", emoji: "🔊" },
    { label: "Seen", emoji: "👀" },
    { label: "You're not alone", emoji: "👥" },
    { label: "Relatable", emoji: "🔗" },
];

export default function EmojiPanel({ gameState }) {
    const [incomingEmojis, setIncomingEmojis] = useState([]);
    const [isMinimized, setIsMinimized] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.innerWidth < 768;
    });

    const currentPlayer = gameState?.players?.[socket.id];

    const gameId = gameState?.id || null;


    const handleSendEmoji = (option) => {
        if (!gameId) {
            console.warn("[EmojiPanel] Emoji not sent: missing gameId", gameState);
            return;
        }

        socket.emit("playerRequest", {
            gameId,
            type: "sendEmoji",
            data: {
                player_name: currentPlayer?.name || "Player",
                emoji: option.emoji,
                label: option.label,
            },
        });
    };

    useEffect(() => {
        const handleReceiveEmoji = ({ emoji, label, player_name }) => {
            const id =
                typeof crypto !== "undefined" && crypto.randomUUID
                    ? crypto.randomUUID()
                    : `${Date.now()}-${Math.random()}`;

            setIncomingEmojis((prev) => [
                ...prev,
                {
                    id,
                    emoji,
                    label,
                    player_name,
                    left: Math.random() * 75 + 10,
                    delay: Math.random() * 0.25,
                },
            ]);

            setTimeout(() => {
                setIncomingEmojis((prev) =>
                    prev.filter((item) => item.id !== id)
                );
            }, 3200);
        };

        socket.on("receiveEmoji", handleReceiveEmoji);

        return () => {
            socket.off("receiveEmoji", handleReceiveEmoji);
        };
    }, []);

    return (
        <>
            {/* Emoji animation layer */}
            <div className="pointer-events-none absolute inset-0 z-[80] overflow-hidden">
                {incomingEmojis.map((item) => (
                    <div
                        key={item.id}
                        className="absolute top-[-80px] animate-[emojiFall_3s_ease-in_forwards]"
                        style={{
                            left: `${item.left}%`,
                            animationDelay: `${item.delay}s`,
                        }}
                    >
                        <div className="animate-[emojiSway_1.6s_ease-in-out_infinite]">
                            <div className="relative flex items-center gap-3 rounded-[22px] border-[4px] border-black bg-white px-4 py-3 shadow-[5px_5px_0_#000]">
                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-[3px] border-black bg-[#fff7cc] text-4xl shadow-[3px_3px_0_#000]">
                                    {item.emoji}
                                </div>

                                <div className="pr-1">
                                    <p className="text-base font-black uppercase leading-none text-black">
                                        {item.label}
                                    </p>

                                    <p className="mt-1 text-[11px] font-black uppercase tracking-wide text-red-500">
                                        {item.player_name}
                                    </p>
                                </div>

                                {/* speech bubble tail */}
                                <div className="absolute -bottom-3 left-8 h-6 w-6 rotate-45 border-b-[4px] border-r-[4px] border-black bg-white" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Emoji picker panel */}
            <div className="absolute bottom-3 left-3 z-[120] rounded-[18px] border-[5px] border-black bg-[#f8f4ea] p-2 shadow-[6px_6px_0_#000]">
                {!isMinimized && (
                    <div className="grid grid-cols-2 gap-2">
                        {emojiOptions.map((option) => (
                            <button
                                key={option.label}
                                type="button"
                                aria-label={option.label}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleSendEmoji(option);
                                }}
                                className="flex h-14 w-14 items-center justify-center rounded-full border-[4px] border-black bg-[#fff7cc] text-3xl shadow-[2px_2px_0_#000] transition hover:-translate-y-1 hover:bg-[#ffde38] hover:shadow-[4px_4px_0_#000] active:translate-y-0 active:shadow-[1px_1px_0_#000]"
                            >
                                {option.emoji}
                            </button>
                        ))}
                    </div>
                )}

                <button
                    type="button"
                    aria-label={isMinimized ? "Open emoji panel" : "Minimize emoji panel"}
                    onClick={(event) => {
                        event.stopPropagation();
                        setIsMinimized((prev) => !prev);
                    }}
                    className={`flex h-11 items-center justify-center rounded-[12px] border-[4px] border-black bg-[#ffde38] text-2xl font-black shadow-[2px_2px_0_#000] transition hover:-translate-y-1 hover:shadow-[4px_4px_0_#000] ${
                        isMinimized ? "w-14" : "mt-3 w-full"
                    }`}
                >
                    {isMinimized ? "😊" : "Close"}
                </button>
            </div>
        </>
    );
}